import { useCanEditDeck } from 'app-redux/deck/selectors'
import { useFloatingMenuOpen } from 'hooks/floatingOptionsMenu'
import { useActionless } from 'app-redux/hooks'
import { SET_ACTIVE_STATE } from 'app-redux/active/actions/types'

import Icon from 'components/elements/Icon'

import styles from './commentBubble.module.scss'

const CommentBubble = () => {
  const canEditDeck = useCanEditDeck()
  const floatingMenuOpen = useFloatingMenuOpen()
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  if (canEditDeck) return null

  return (
    <button
      className={`${styles.bubble} ${floatingMenuOpen ? styles.hidden : ''}`}
      onClick={() => setActiveState({ interactionOverlay: true })}>
      <Icon name="chat" />
    </button>
  )
}

export default CommentBubble
